const KEYS_STORAGE = 'opengate_api_keys_v1'
const USAGE_STORAGE = 'opengate_usage_v1'

function uid() {
  return 'og_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4)
}

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw)
  } catch (e) {
    return fallback
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function listKeys() {
  return readJson(KEYS_STORAGE, [])
}

export function createKey(name) {
  const label = String(name || '').trim() || '默认密钥'
  const item = {
    id: uid(),
    name: label,
    key: 'og_live_' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2, 10),
    secret: 'sk_' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2, 14),
    createdAt: new Date().toISOString(),
    lastUsedAt: null,
    enabled: true
  }
  const list = listKeys()
  list.unshift(item)
  writeJson(KEYS_STORAGE, list)
  return item
}

export function revokeKey(id) {
  const list = listKeys().map(k => (k.id === id ? { ...k, enabled: false } : k))
  writeJson(KEYS_STORAGE, list)
  return list
}

export function deleteKey(id) {
  const list = listKeys().filter(k => k.id !== id)
  writeJson(KEYS_STORAGE, list)
  return list
}

export function getUsage() {
  const cached = readJson(USAGE_STORAGE, null)
  if (cached && Array.isArray(cached.days)) return cached
  const days = []
  for (let i = 6; i >= 0; i--) {
    const d = new Date()
    d.setDate(d.getDate() - i)
    days.push({
      date: d.toISOString().slice(0, 10),
      calls: Math.floor(80 + Math.random() * 320),
      errors: Math.floor(Math.random() * 12)
    })
  }
  const data = {
    quota: 10000,
    used: days.reduce((s, x) => s + x.calls, 0),
    days
  }
  writeJson(USAGE_STORAGE, data)
  return data
}

export function maskSecret(s) {
  const str = String(s || '')
  if (str.length <= 8) return '********'
  return str.slice(0, 6) + '••••••••' + str.slice(-4)
}
